import { useNavigate, useLocation } from "react-router-dom";
import { getHospitalList } from "../../../../Service/RM";
import { useState, useMemo, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { VscEye } from "react-icons/vsc";
import { IoIosAddCircleOutline } from "react-icons/io";
import Loader from "../../../../reusableUI/loader";
import { formatPhoneNumber } from "../../../../utils/Functions";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import { CommonImages, partnerPortalImages } from "../../../../reusableUI/images";
import ReusableTable from "../../../../reusableUI/table";
import Page from "../../../../reusableUI/page";
import TabButtons from "../../../../reusableUI/tabButtons";
import Performence from "./performence";

const Hospital = ({ searchTerm }) => {
  const [loading, setLoading] = useState(true);
  const [paginationPage, setPaginationPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("all");
  const [userList, setUserList] = useState([]);
  const [noUsersFound, setNoUsersFound] = useState(false);
  const [selectedTab, setSelectedTab] = useState("partner");
  const [selectedPageCount, setSelectedPageCount] = useState(() => {
    const savedPageCount = localStorage.getItem("pageCount");
    return savedPageCount ? parseInt(savedPageCount, 10) : 50;
  });

  const [sortBy, setSortBy] = useState(() => {
    const savedSortBy = localStorage.getItem("sortBy");
    return savedSortBy ? JSON.parse(savedSortBy) : [];
  });

  const navigate = useNavigate();
  const location = useLocation();
  const viewPage = [{ value: "partner", label: "Add Partner" }, { value: "performance", label: "Partner Performance" }]

  useEffect(() => {
    getUserList();
    const savedValue = localStorage.getItem("selectedValue");
    if (savedValue) {
      setSelectedValue(savedValue);
    }
  }, []);

  useEffect(() => {
    if (location.state?.currentPage !== undefined) {
      setPaginationPage(location.state.currentPage);
    }
  }, [location.state]);

  const getUserList = async () => {
    setLoading(true); // Start loading
    try {
      const result = await getHospitalList();
      if (!result.error && Array.isArray(result.data)) {
        setUserList(result.data);
      } else {
        console.error("Failed to fetch hospital list");
        setUserList([]); // Set empty array on error
      }
    } catch (error) {
      console.error("Error fetching hospital list:", error);
      setUserList([]); // Set empty array on error
    } finally {
      setLoading(false); // Always stop loading
    }
  };

  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value);
    localStorage.setItem("selectedValue", event.target.value);
  };

  const onSelect = (option) => {
    setSelectedTab(option);
  };

  const AddHospital = () => {
    localStorage.setItem("profilePage", "hospital");
    navigate("/partnerEdit");
  };

  console.log(userList)

  const getColumns = () => [
    {
      Header: "Partner Name",
      accessor: "hospitalName",
      id: "hospitalName",
      width: 200,
      minWidth: 180,
      maxWidth: 250,
      disableSortBy: false,
      sortType: (rowA, rowB) => {
        const nameA = (rowA.original?.basicInfo?.name || "").toLowerCase();
        const nameB = (rowB.original?.basicInfo?.name || "").toLowerCase();
        return nameA.localeCompare(nameB);
      },
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <div className="flex gap-2">
          {/* <img
            src={original?.basicInfo?.bannerImage ? original?.basicInfo?.bannerImage : partnerPortalImages.partnerDefaultDp}
            alt="Profile"
            className="h-10 w-10 "
          /> */}
          <span
            className="text-blue-600 text-[12px] truncate max-w-[100px] inline-block"
            title={original?.basicInfo?.name || "-"}
          >
            {original?.basicInfo?.name || "-"}
          </span>
        </div>

      ),
    },
    {
      Header: "Provider Type",
      accessor: "providerType",
      id: "providerType",
      width: 120,
      minWidth: 110,
      maxWidth: 140,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <span className="text-blue-600 text-[12px]">
          {capitalizeFirstLetter(original?.providerType) || "-"}
        </span>
      ),
    },

    {
      Header: "Location",
      accessor: "location",
      id: "location",
      width: 120,
      minWidth: 100,
      maxWidth: 140,
      disableSortBy: false,
      sortType: (rowA, rowB) => {
        const locA = (rowA.original?.addressInfo?.city || "").toLowerCase();
        const locB = (rowB.original?.addressInfo?.city || "").toLowerCase();
        if (!locA && locB) return 1;
        if (locA && !locB) return -1;
        return locA.localeCompare(locB);
      },
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <span className="text-[12px]">
          {capitalizeFirstLetter(original?.addressInfo?.city || "-")}
        </span>
      ),
    },
    {
      Header: "Contact Person",
      accessor: "contactPerson",
      id: "contactPerson",
      width: 160,
      minWidth: 140,
      maxWidth: 200,
      disableSortBy: false,
      sortType: (rowA, rowB) => {
        const nameA = (
          rowA.original?.contactInfo?.[0]?.name || ""
        ).toLowerCase();
        const nameB = (
          rowB.original?.contactInfo?.[0]?.name || ""
        ).toLowerCase();
        return nameA.localeCompare(nameB);
      },
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <span
          className="text-[12px] truncate max-w-[100px] inline-block"
          title={original?.contactInfo?.[0]?.name || "-"}
        >
          {original?.contactInfo?.[0]?.name || "-"}
        </span>
      ),
    },
    {
      Header: "Contact Number",
      accessor: "contactNumber",
      id: "contactNumber",
      width: 140,
      minWidth: 130,
      maxWidth: 160,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "center",
        padding: "6px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => {
        const rawPhone = original?.contactInfo?.[0]?.phone;
        const phoneWithCountryCode = rawPhone ? Number(rawPhone) : null;

        return (
          <span className="text-blue-600 text-[12px] whitespace-nowrap">
            {phoneWithCountryCode
              ? formatPhoneNumber(phoneWithCountryCode)
              : "-"}
          </span>
        );
      },
    },
    {
      Header: "Email Id",
      accessor: "email",
      id: "email",
      width: 200,
      minWidth: 180,
      maxWidth: 250,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <span
          className="text-[12px] truncate max-w-[100px] inline-block"
          title={original?.contactInfo?.[0]?.email || "-"}
        >
          {original?.contactInfo?.[0]?.email || "-"}
        </span>
      ),
    },
    {
      Header: "Referral Code",
      accessor: "referralCode",
      id: "referralCode",
      width: 120,
      minWidth: 110,
      maxWidth: 140,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <span className="text-[12px]">{original?.referralCode || "-"}</span>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      id: "action",
      width: 70,
      minWidth: 60,
      maxWidth: 90,
      disableSortBy: true,
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row }) => (
        <button
          onClick={() => {
            localStorage.setItem("profilePage", "hospital");
            navigate("/hospitalProfile", {
              state: {
                userID: row.original._id,
              },
            });
          }}
          className="inline-flex items-center justify-center hover:opacity-70 transition-opacity ml-2"
          aria-label="View Profile"
        >
          <VscEye size={18} color="blue" />
        </button>
      ),
    },
  ];

  const filteredData = useMemo(() => {
    let filtered = Array.isArray(userList) ? [...userList] : [];

    const value = selectedValue?.toLowerCase();

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter((item) => {
        const name = item?.basicInfo?.name?.toLowerCase() || "";
        const phone = String(item?.contactInfo?.[0]?.phone ?? "");
        const city = item?.addressInfo?.city?.toLowerCase() || "";

        return (
          name.includes(term) || phone.includes(term) || city.includes(term)
        );
      });
    }

    const noResults = filtered.length === 0;
    setNoUsersFound(noResults);

    return noResults ? [] : filtered.reverse();
  }, [selectedValue, userList, searchTerm]);

  // console.log(filteredData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex, sortBy: currentSortBy },
  } = useTable(
    {
      columns: useMemo(() => getColumns(), [selectedValue]),
      data: filteredData,
      initialState: {
        pageSize: selectedPageCount,
        pageIndex: paginationPage,
        sortBy,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    localStorage.setItem("sortBy", JSON.stringify(currentSortBy));
  }, [currentSortBy]);

  useEffect(() => {
    if (pageIndex !== paginationPage) {
      setPaginationPage(pageIndex);
    }
  }, [pageIndex]);

  // Show loader while loading
  if (loading) {
    return (
      <div className="flex justify-center items-center h-[85vh] bg-[#F3F6F5]">
        <Loader loading={loading} />
      </div>
    );
  }

  return (
    <div className="bg-[#F3F6F5]">
      {/* <TabButtons
        options={viewPage}
        selectedOption={selectedTab}
        onSelect={onSelect}
      /> */}

      {selectedTab !== "performance" ? <div className="overflow-x-auto bg-white rounded-2xl w-auto md:w-auto lg:w-auto shadow-lg p-2 h-[88vh] m-2 flex flex-col gap-3">
        <div className="flex justify-between items-center mt-[-25px]">
          <div className="flex flex-row items-center mt-4">
            <p className="text-[14px] font-bold ml-2 mt-4">
              Partner List ({filteredData.length})
            </p>
          </div>

          <div
            className="flex flex-row items-center bg-custom-gradient gap-1 p-2 rounded-md cursor-pointer m-2 mt-8"
            onClick={AddHospital}
          >
            <IoIosAddCircleOutline color="white" size={18} />
            <p className="text-[12px] text-[white]">Add Partner</p>
          </div>
        </div>

        <div className="overflow-x-auto max-h-[70vh] mt-[-10px]">
          <div className="min-w-full w-[100%]">
            {noUsersFound ? (
              <div className="flex flex-col justify-center items-center h-[50vh]">
                <p className="text-gray-500 text-[14px] font-poppins">
                  No partners found
                </p>
                {searchTerm && (
                  <p className="text-gray-400 text-[12px] font-poppins mt-2">
                    Try adjusting your search
                  </p>
                )}
              </div>
            ) : (
              <ReusableTable
                columns={getColumns()}
                getTableProps={getTableProps}
                getTableBodyProps={getTableBodyProps}
                headerGroups={headerGroups}
                tablePage={tablePage}
                prepareRow={prepareRow}
                filterIcon={CommonImages.filter}
                searchTerm={searchTerm}
              />
            )}
          </div>
        </div>

        {!noUsersFound && (
          <div className="mb-2">
            <Page
              paginationPage={paginationPage}
              nextPage={nextPage}
              previousPage={previousPage}
              canPreviousPage={canPreviousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              screen="hospital"
            />
          </div>
        )}
      </div> : <Performence />}
    </div>
  );
};

export default Hospital;
